const CLIENT_ID_KEY = 'portrait_client_id';
const LEGACY_PREFIX = ['paw', 'bond'].join('');
const LEGACY_CLIENT_ID_KEY = `${LEGACY_PREFIX}_client_id`;

export function getClientId() {
  const existing = window.localStorage.getItem(CLIENT_ID_KEY) || window.localStorage.getItem(LEGACY_CLIENT_ID_KEY);
  if (existing) return existing;

  const next =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `client-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  window.localStorage.setItem(CLIENT_ID_KEY, next);
  return next;
}
